<template>
    <el-row :gutter="30" class="mw-100">
        <el-col :lg="24" :xs="24">
           <div class="mb-20 d-flex ">
                <el-button type="primary" @click="handleAddFooterContact" class="ml-auto">
                    <span class="color-white">
                        add footer Contact
                    </span>
                </el-button>
            </div>
            <el-card class="box-card">
                <el-table :data="footerContacts" style="width: 100%">
                    
                    
                    <el-table-column label="image" prop="iconURL" width="80" >
                        <template #default="scope">
                            <el-image 
                                style="width: 50px; height: 50px" 
                                :src="$getImage(scope.row.iconURL) || ''" 
                                fit="cover"
                                :zoom-rate="1.2"
                                :preview-src-list="[$getImage(scope.row.iconURL)]"
                                :preview-teleported="true"
                                class="bg-theme"
                            >
                                <template #error>
                                    <div class="image-slot">
                                        <font-awesome-icon :icon="['fas', 'image']" />
                                    </div>
                                </template>
                            </el-image>
                        </template>
                    </el-table-column>
                    <el-table-column label="Type" prop="contactType" />
                    <el-table-column label="contact value En">
                        <template #default="scope">
                           {{$getLocaleData(scope.row.translates,'en_us').title}}
                        </template>
                    </el-table-column>

              

                    <el-table-column label="contact value Ar" >
                        <template #default="scope">
                           <div class="">
                               {{$getLocaleData(scope.row.translates,'ar_sa').title}}
                           </div>
                        </template>
                    </el-table-column>
                  
                    <el-table-column label="Operations" width="100">
                        <template #default="scope">
                            <el-popconfirm 
                                title="Are you sure to delete this?"
                                @confirm="deleteContact(scope.row)"
                            >
                                <template #reference>
                                   <font-awesome-icon :icon="['fas', 'trash']" style="width:20px" class="cursor-pointer color-red" />
                                </template>
                            </el-popconfirm>
                            
                        </template>
                    </el-table-column>
                </el-table>
               
            </el-card>
        </el-col>
    </el-row>
</template>
<script>
export default {
    computed:{
        cachedFooterContacts(){
            return JSON.parse(localStorage.getItem('adminStore'))?.website?.settings?.footer?.footerContacts?.list || []
        },
    },
    data(){
        return{
            footerContacts:[],
            footerContactStatus:[],
           
        }
    },
    async mounted(){
        if (!this.cachedFooterContacts?.length){
            this.getFooterContact();
        }else{
            this.footerContacts = this.cachedFooterContacts;
          
        }
        
       
    },
    
    methods:{
       
        async getFooterContact(){
            const response = await this.$store.dispatch('getFooterContact');
            this.footerContacts = response;
             
        },
        
        async deleteContact(contactData){
            
            let dataToSend = {
                id:contactData.id
            }
            const response = await this.$store.dispatch('deleteContact',dataToSend);
            if (response.data.status == 1){
                this.getFooterContact();
                this.$notify({
                    title:String(response.status),
                    message:response.data.message,
                    type:'success',
                })
            }
            
        },
        async handleAddFooterContact(){
            this.$router.push({
                name:'manage-footer-contact'
            })
        },
        async handleEditFooterContact(footerContact){
            await this.$store.dispatch('storeCurrentFooterContactToView',footerContact)
            this.$router.push({
                name:'manage-footer-contact',
                params:{
                    id:footerContact.id
                }
            })
        },
      
    
       
        
    }
}
</script>
<style lang="scss">
    .text-right.rtl {
        .cell {
            text-align: right;
            direction: rtl;
        }
    }
</style>